export var tableHeaderContainer = {
  padding: '0.8em 1em',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  gap: '0.8em'
};